export default "__VITE_ASSET__B3bHvLIs__"